import logo from './logo.svg';
import './App.css';
import {useNavigate, Routes, Route, Link, createBrowserRouter, RouterProvider, BrowserRouter } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import LandingPage from './pages/LandingPage';
import Layout from './components/layout/Layout';
import InvestmentRequestPage from './pages/InvestmentRequestPage';
import GalleryPage from './pages/GalleryPage';
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import Menu from "./components/menu/Menu";
import "./i18n";

function App() {
    const isMobile = window.innerWidth <= 768;
    // const { i18n } = useTranslation();
    // useEffect(() => {
    //   document.documentElement.dir = i18n.language === "ar" ? "ltr" : "rtl";
    // }, [i18n.language]);


//   const router = createBrowserRouter ([
// {
//     path: "/",
//     element: <Layout/>,
//     children: [
//       {
//         path:"/",
//         element: <LandingPage/>
//       },
//     ]},
//     {
//       path:"/investmentRequest",
//       element: <InvestmentRequestPage/>
//     }
  
//   ]);


  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<LandingPage />} />
            <Route
              path="investmentRequest"
              element={<InvestmentRequestPage />}
            />
            <Route path="gallery" element={<GalleryPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
